// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"wbac_innerWrapper__AeWRv","logoWrapper":"wbac_logoWrapper__apBOK","logo":"wbac_logo__rsw9J","heading":"wbac_heading___xLn_","cta":"wbac_cta__K62qP"};